import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import DashboardWrapper from "shared/components/common/dashboardWrapper";
import { routeConstant } from "./routeConstant";

interface LayoutProps {
  path: string;
  title: string;
  Component: any;
}

const Layout = ({ title, Component }: Partial<LayoutProps>) => {
  const {
    auth: { isLoggedIn },
  } = useSelector((state: any) => state.root);
  const location = useLocation();

  useEffect(() => {
    document.title = title + " | Flamepoint";
    // eslint-disable-next-line
  });

  if (!isLoggedIn && location.pathname === routeConstant.login.path) {
    return (
      <div style={{ backgroundColor: "#18212b" }}>
        <Component />
      </div>
    );
  } else {
    return (
      <DashboardWrapper>
        <Component />
      </DashboardWrapper>
    );
  }
};

export default Layout;
